module.exports = __webpack_public_path__ + "static/img/empty2.4827f7c9.png";